import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DashboardProductCard } from './AgroDashboard';
import './CategoryProducts.css';


const CategoryProducts = ({ products, cart, wishlist, addToCart, updateQuantity, toggleWishlist }) => {
  const { catName } = useParams();
  const navigate = useNavigate();

  // Filter with safety checks
  const filtered = (products || []).filter(
    p => p.category?.toLowerCase() === catName?.toLowerCase()
  );

  return (
    <div className="category-view-container">
      <div className="category-header">
        <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
        <h2>{catName}</h2>
        <p>{filtered.length} specialized items found</p>
      </div>

      <div className="product-grid">
        {filtered.map(item => (
          <DashboardProductCard
            key={item.id}
            item={item}
            cart={cart || []} // Default to empty array to prevent 'some' error
            wishlist={wishlist || []} // Default to empty array to prevent 'some' error
            addToCart={addToCart}
            updateQuantity={updateQuantity}
            toggleWishlist={toggleWishlist}
            // Ensure this prop is calculated correctly
            isInWishlist={wishlist?.some(w => w.id === item.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryProducts;